import { GraduationCap } from "lucide-react";
import { FORMAL } from "../data/content";
import { SectionHeader } from "./SectionHeader";
import { Reveal } from "./Reveal";

export const FormalEducation = () => (
    <section
        id="pendidikan"
        data-testid="pendidikan-section"
        aria-labelledby="pendidikan-title"
        className="bg-bh-offwhite py-20 sm:py-24 scroll-mt-20"
    >
        <div className="max-w-[1565px] mx-auto">
            <SectionHeader
                eyebrow={FORMAL.eyebrow}
                title={FORMAL.title}
                sub={FORMAL.note}
                testid="pendidikan-title"
            />
            <div className="px-6 sm:px-8 grid sm:grid-cols-2 gap-6 max-w-5xl mx-auto">
                {FORMAL.items.map((item, i) => (
                    <Reveal key={item.title} delay={i * 0.12}>
                        <article
                            data-testid={`formal-${item.title.toLowerCase()}`}
                            className="h-full rounded-2xl border border-bh-green/12 bg-white px-7 py-8 sm:px-9"
                        >
                            <div className="flex items-center gap-4 mb-6">
                                <span className="flex items-center justify-center w-12 h-12 rounded-full bg-bh-light shrink-0">
                                    <GraduationCap className="w-5 h-5 text-bh-green" aria-hidden="true" />
                                </span>
                                <div>
                                    <h3 className="font-serif text-2xl font-bold text-bh-deep leading-tight">
                                        {item.title}
                                    </h3>
                                    <p className="text-[11px] uppercase tracking-[0.16em] text-bh-gold font-semibold mt-1">
                                        {item.phase}
                                    </p>
                                </div>
                            </div>
                            {item.paragraphs.map((paragraph, j) => (
                                <p
                                    key={j}
                                    className="text-sm sm:text-base leading-relaxed text-bh-gray mt-4 first:mt-0"
                                >
                                    {paragraph}
                                </p>
                            ))}
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
